import classNames from 'classnames';
import api from '../../../../../../api';
import { batchRequest } from '../../../../../../common/services/request-batcher';
import * as urlBuilder from '../../../../../../common/services/url-builder';
import { preventJavascriptUrls } from '../../../../../../services/security';
import { withData } from '../../../../../hoc/withData';

function NoMention({ loginname }) {
    return <span>{loginname} </span>;
}

function Mention({ user, loginname }) {
    if (!user) {
        return <NoMention loginname={loginname} />;
    }

    const { id, name } = user;
    const href = preventJavascriptUrls(urlBuilder.linkToNewUserProfile(id));
    const linkProps = {
        href,
        className: classNames('ui-mention'),
    };
    return <a {...linkProps}>{name}</a>;
}

export default withData({
    resolve: {
        user: ({ loginname }) => batchRequest(api.usersMedium.getByLoginnames, loginname, 'loginname'),
    },
    pendingComponent: NoMention,
    errorComponent: NoMention,
})(Mention);
